// test228
(228 && 0);
